  document.addEventListener("DOMContentLoaded", () => {
    const calculatorData = document.getElementById("TileCalculatorData");
    if (!calculatorData) return;

    let coveragePerBox = parseFloat(calculatorData.dataset.coverage) || 1;
    const piecesPerBox = parseInt(calculatorData.dataset.perBox) || 1;
    const tileSize = calculatorData.dataset.size || "";
    const sellBy = calculatorData.dataset.sellBy || "";
    const minQty = parseInt(calculatorData.dataset.minQty) || 1;
    const minSqft = parseFloat(calculatorData.dataset.minSqft) || 1;
    const boxPrice = (parseInt(calculatorData.dataset.price) || 0) / 100;
    const wasteVal =  (parseFloat(calculatorData.dataset.wasteVal) || 10) / 100;

    const moneyFormatter = new Intl.NumberFormat(
      document.documentElement.lang || "en-US",
      {
        style: "currency",
        currency: Shopify.currency?.active || "USD",
      },
    );

    const labelCoverage = document.querySelector(".label-coverage");
    const labelSqft = document.querySelector(".label-sqft");
    const labelQuantity = document.querySelector(".label-quantity");
    const labelPrice = document.querySelectorAll(".label-price");

    const areaInput = document.getElementById("tileAreaInput");
    const wasteToggle = document.getElementById("tileWasteToggle");
    const coveragePerBoxEl = document.getElementById("coveragePerBox");
    const totalAreaEl = document.getElementById("totalArea");
    const boxesRequiredEl = document.getElementById("boxesRequired");
    const piecesRequiredEl = document.getElementById("piecesRequired");
    const actualCoverageEl = document.getElementById("actualCoverage");
    const pricePerBoxEl = document.getElementById("pricePerBox");
    const pricePerTileEl = document.getElementById("pricePerTile");
    const projectCostEl = document.getElementById("projectCost");
    const calculatorMessageEl = document.getElementById('calculatorMessage');
    const sqftPerBoxEl = document.getElementById('sqftPerBox');
    const atcContainerEl = document.querySelector('.product-add-to-cart-container');
    const addToCartBtn = atcContainerEl.querySelector(
      'product-form button[type="submit"]',
    );

    const qtyInput =
        atcContainerEl.querySelector("quantity-input input") ||
        atcContainerEl.querySelector('[name="quantity"]');
    // qtyInput.disabled = true
    // atcContainerEl.querySelectorAll('quantity-selector button').forEach(button => button.disabled = true);

    const finalQty = Math.max(boxesRequired, qtyInput.value);
    const sqft = parseFloat(areaInput?.value) || 0;

    const meetsMinSqft = sqft >= minSqft;

    const isValid =
      sqft > 0 &&
      meetsMinSqft;

    if (coveragePerBoxEl) {
      if (sellBy == 'item') {
        const tileCoverage = getTileCoverageFromSize(tileSize);
        coveragePerBox = parseFloat(tileCoverage).toFixed(3);
      }
      coveragePerBoxEl.textContent = `${coveragePerBox} sq ft`;
      if (sellBy == 'box'){
        coveragePerBoxEl.textContent = `${piecesPerBox} tiles`;
      }
    }

    if (pricePerBoxEl) {
      if (sellBy == "box") {
        pricePerBoxEl.textContent = moneyFormatter.format(boxPrice);
      }
      else {
        pricePerBoxEl.closest('.tile-card').style.display= 'none'
      }
    }

    if(sqftPerBoxEl){
      if (sellBy != "box") {
        sqftPerBoxEl.closest('.tile-card').style.display= 'none'
      }
    }

    if (pricePerTileEl && piecesPerBox) {
      pricePerTileEl.textContent = moneyFormatter.format(boxPrice / piecesPerBox);
    }

    if (calculatorMessageEl) {

      if (!meetsMinSqft) {
        calculatorMessageEl.textContent =
          `${minSqft} sq ft`;
      }
      else {
        calculatorMessageEl.textContent =
          `No limit`;
      }
    }

    if (addToCartBtn) {
        addToCartBtn.disabled = !isValid;
    }

    function getTileCoverageFromSize(size) {
        if (!size) return 0;

        const match = size.match(/(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)/i);

        if (!match) return 0;

        const widthInches = parseFloat(match[1]);
        const lengthInches = parseFloat(match[2]);

        return (widthInches * lengthInches) / 144;
    }
    function updateQuantity(requiredQty) {
        if (!qtyInput) return;

        // Set calculated quantity (boxes, tiles or items)
        const finalQty = Math.max(requiredQty, minQty);
        qtyInput.value = finalQty;

        // Validate against entered area
        const sqft = parseFloat(areaInput?.value) || 0;
        const adjustedArea = wasteToggle?.checked? sqft * (1 + wasteVal): sqft;

        const meetsMinArea = adjustedArea >= minSqft;
        const meetsMinQuantity = finalQty >= minQty;

        const isValid =
            adjustedArea > 0 &&
            meetsMinArea &&
            meetsMinQuantity;

        if (addToCartBtn) {
            addToCartBtn.disabled = !isValid;
        }

        // Notify Shopify's product form
        qtyInput.dispatchEvent(
            new Event("input", {
            bubbles: true,
            }),console.log('change triggered')
        );

        qtyInput.dispatchEvent(
            new Event("change", {
            bubbles: true,
            }),console.log('change triggered')
        );
    }

    function updateLabels() {
      if (sellBy === "box") {
        labelCoverage.textContent = "Tiles per Box";
        labelSqft.textContent = "Sq Ft per Box";
        labelQuantity.textContent = "Number of Boxes";
        labelPrice.forEach(label => {
          label.textContent = "Price per Box";
        });
      }
       if (sellBy === 'sqft'){
        labelCoverage.textContent = "Coverage per Tile";
        labelSqft.textContent = "Sq Ft per Tile";
        labelQuantity.textContent = "Number of Tiles";
        labelPrice.forEach(label => {
          label.textContent = "Price per Sq ft";
        });
      } 
      if (sellBy === 'item') {
        labelCoverage.textContent = "Coverage per Tile";
        labelSqft.textContent = "Sq Ft per Tile";
        labelQuantity.textContent = "Number of Tiles";
        labelPrice.forEach(label => {
          label.textContent = "Price per Tile";
        });
      }
    }

    function calculate() {
        const sqft = parseFloat(areaInput?.value) || 0;

        if (sqft <= 0) {
            if (totalAreaEl) totalAreaEl.textContent = "--";
            if (boxesRequiredEl) boxesRequiredEl.textContent = "--";
            if (piecesRequiredEl) piecesRequiredEl.textContent = "--";
            if (actualCoverageEl) actualCoverageEl.textContent = "--";
            if (projectCostEl) projectCostEl.textContent = "--";
            return;
        }

        const adjustedArea = wasteToggle?.checked? sqft * (1 + wasteVal): sqft;

        let quantityRequired = 1;
        let boxesRequired = 0;
        let piecesRequired = 0;
        let actualCoverage = 0;
        let projectCost = 0;

        // =========================
        // BOX MODE
        // =========================
        if (sellBy === "box") {
            boxesRequired = Math.ceil(adjustedArea / coveragePerBox);

            quantityRequired = Math.max(boxesRequired, minQty);

            piecesRequired = boxesRequired * piecesPerBox;

            actualCoverage = boxesRequired * coveragePerBox;

            projectCost = quantityRequired * boxPrice;
        }

        // =========================
        // SQFT MODE (TILE BASED)
        // =========================
        else if (sellBy === "sqft") {

          // coveragePerBox is reused as "sqft per tile"

          // Informational only
          piecesRequired = Math.round(adjustedArea / coveragePerBox);

          // Customer purchases square feet
          quantityRequired = Math.max(
              Math.round(adjustedArea),
              minQty
          );

          // Display only
          boxesRequired = piecesRequired;

          actualCoverage = quantityRequired;

          // Price is per sq ft
          projectCost = quantityRequired * boxPrice;
        }

        // =========================
        // ITEM MODE (DIRECT QUANTITY)
        // =========================
        else if (sellBy === "item") {
            const tileCoverage = getTileCoverageFromSize(tileSize);

            if (!tileCoverage) {
                console.warn("Invalid tile size:", tileSize);
                return;
            }

            quantityRequired = Math.ceil(adjustedArea / tileCoverage);

            boxesRequired = quantityRequired;
            piecesRequired = quantityRequired;

            actualCoverage = quantityRequired * tileCoverage;

            projectCost = quantityRequired * boxPrice;
        }

        // =========================
        // UI UPDATES
        // =========================

        if (totalAreaEl) {
            totalAreaEl.textContent = `${adjustedArea.toFixed(2)} sq ft`;
        }

        if (boxesRequiredEl) {
            boxesRequiredEl.textContent = boxesRequired;
        }

        if (piecesRequiredEl) {
            piecesRequiredEl.textContent = piecesRequired;
        }

        if (actualCoverageEl) {
            actualCoverageEl.textContent = `${actualCoverage.toFixed(2)} sq ft`;
        }

        if (projectCostEl) {
            projectCostEl.textContent = moneyFormatter.format(projectCost);
        }

        if (sqftPerBoxEl) {
            if (sellBy === "box") {
            sqftPerBoxEl.textContent = `${coveragePerBox} sq ft / box`;
            } else if (sellBy === "sqft") {
            sqftPerBoxEl.textContent = `${coveragePerBox.toFixed(2)} sq ft / tile`;
            } else {
            sqftPerBoxEl.closest('.tile-card').style.display = 'none';
            }
        }

        updateQuantity(quantityRequired);
    }

    function validateAreaInput(e) {
      
      let value = e.target.value;

      // Remove everything except digits and decimal point
      value = value.replace(/[^\d.]/g, "");

      // Allow only one decimal point
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }

      e.target.value = value;
    }

    areaInput?.addEventListener("input", (e) => {
      validateAreaInput(e);
      calculate();
    });
    wasteToggle?.addEventListener("change", calculate);
    calculate();
    updateLabels();
  });